import { callAPI } from "../config/AxiosTemplate";

import { API_RESPONSE_STATUS_CODES, API } from "../Utils/Constants";

export const getAmortizationTableAction = (request, callback) => {
  callAPI(
    "getAmortizationTable",
    `${API.getAmortizationTable}${request.applicationId}&limit=${request.limit}&offset=${request.offset}`,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

export const getEmiAmountSplitupAction = (request, callback) => {
  callAPI(
    "getEmiAmountSplitupAction",
    `${API.getEmiAmountSplitup}?ix=${request.ix}&lid=${request.lid}&ic=${request.ic}&dd=${request.dd}`,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};
